var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"cta"},[_c('button',{staticClass:"button",on:{"click":function($event){return _vm.submitForm()}}},[_vm._v(_vm._s(_vm.localizer.get("App.MyBremboParts.Training_SetTestAsCompleted")))])])
}
var staticRenderFns = []

export { render, staticRenderFns }